// eslint-disable-next-line boundaries/no-unknown-files
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { PAGE_ROUTE } from '@app/constants/page-route';
import { ErrorPageType } from '@app/enums/error-page-type';

export const errorPageGuard: CanActivateFn = (next: ActivatedRouteSnapshot) => {
    const router = inject(Router);

    const id = Number(next.paramMap.get('id'));
    if (typeof id === 'number' && id > 0) {
        if (id === (ErrorPageType.Unauthorized as number)) return true;
        if (id === (ErrorPageType.NotFound as number)) return true;
    }

    return router.parseUrl(
        `${PAGE_ROUTE.Main}/${PAGE_ROUTE.Error}/${ErrorPageType.NotFound}`,
    );
};
